import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../keycloack/auth.service';
import { ROLES } from '../utils/constants';

/**
 * canMatch — ritorna solo true/false per decidere se la rotta matcha.
 * NON ritorna UrlTree (causa freeze su Angular).
 */
export const routeRoleGuard = (expectedRoles: ROLES[]): CanMatchFn => {
  return (): boolean => {
    const auth = inject(AuthService);
    const userRoles = auth.getRoles();
    if (userRoles.length === 0) return true;
    return userRoles.some((r) => expectedRoles.includes(r));
  };
};

/**
 * canActivate — fa il redirect quando il ruolo non è autorizzato.
 */
export const routeRoleActivateGuard = (expectedRoles: ROLES[]): CanActivateFn => {
  return (): boolean | UrlTree => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const userRoles = auth.getRoles();

    if (userRoles.some((r) => expectedRoles.includes(r))) return true;

    if (userRoles.includes(ROLES.superadmin)) {
      return router.createUrlTree(['/superadmin/tenants']);
    }
    if (userRoles.includes(ROLES.supporto)) {
      return router.createUrlTree(['/ticketing']);
    }
    return router.createUrlTree(['/avvisi']);
  };
};
